import { PulseLoader } from "react-spinners";

const FallbackLoading = ({ height }) => {
  return (
    <div
      className="text-primary d-flex justify-content-center align-items-center"
      style={{ minHeight: height ? height : "100vh" }}
    >
      <PulseLoader color="#116C96" />
    </div>
  );
};

export default FallbackLoading;
